// Single source of truth for article categories — used by the public
// WIM Blog / Care News filter tabs (Blog.jsx, CareNews.jsx) AND by the
// Admin article editor's category dropdown, so Admin never invents a
// new/duplicate category system. "All" is a filter-only pseudo-category
// (not a real value to store on an article) — excluded from the Admin
// list via the *_FOR_ADMIN exports below.

export const BLOG_CATEGORIES = [
  "All",
  "Independent Care",
  "Payment & Contracts",
  "CQC & Regulation",
  "Tax & Self-Employment",
  "Family Guidance",
  "Safety & Safeguarding",
  "Hospital & NHS",
  "Professional Boundaries",
  "Care News & Policy Watch",
];

export const NEWS_CATEGORIES = [
  "All",
  "Policy & Legislation",
  "Direct Payments & Funding",
  "Workforce & Industry Trends",
  "CQC & Regulation",
  "NHS & Social Care",
];

export const BLOG_CATEGORIES_FOR_ADMIN = BLOG_CATEGORIES.filter((c) => c !== "All");
export const NEWS_CATEGORIES_FOR_ADMIN = NEWS_CATEGORIES.filter((c) => c !== "All");
